export const Paragraph = 'atlantis-paragraph-placeholder';
export const Span = 'atlantis-span-placeholder';
export const Heading = 'atlantis-heading-placeholder';
export const Glowing = 'atlantis-glowing-placeholder';
export const FormControl = 'atlantis-form-control-placeholder';
export const DataTable = 'atlantis-data-table-placeholder';
export const AppCard = 'atlantis-app-card-placeholder';
export const ListGroupItem = 'atlantis-action-list-group-item-placeholder';